import LogicaAPI from "./logicaapi";

class VoucherCode extends LogicaAPI {
  async check(code, { productId, paymentMethodId }) {
    // APIの使用上コースIDも指定できるが、TVODの購入時にしか使わない想定なので除外
    const params = {
      product_id: productId,
      payment_method_id: paymentMethodId,
    };
    if (this.config?.userId) {
      params.user_id = this.config.userId;
    }
    return this.get(`/api/v1/voucher_codes/check/${code}`, {params});
  }
}
export default VoucherCode;
